import { createAction } from 'redux-actions';

import types from './types';

const _setMinicartPopoverData = createAction(types.SET_MINICART_POPOVER_DATA);
const setWindowSize = createAction(types.SET_WINDOW_SIZE);
const _windowResize = createAction(types.WINDOW_RESIZE);
const addToVisibleElements = createAction(types.ADD_TO_VISIBLE_ELEMENTS);
const removeFromVisibleElements = createAction(types.REMOVE_FROM_VISIBLE_ELEMENTS);
const hideFiltersMenu = createAction(types.HIDE_FILTERS_MENU);
const showFiltersMenu = createAction(types.SHOW_FILTERS_MENU);
const scrollToAppliedFilter = createAction(types.SCROLL_TO_APPLIED_FILTER);
const showModal = createAction(types.OPEN_MODAL);
const closeModal = () => showModal(null);
const openDialog = createAction(types.OPEN_DIALOG);
const closeDialog = createAction(types.CLOSE_DIALOG);
const closeDialogByName = createAction(types.CLOSE_DIALOG_BY_NAME);
const okModal = createAction(types.OK_MODAL);
const cancelModal = createAction(types.CANCEL_MODAL);
const setScrollTop = createAction(types.SET_SCROLL_TOP);
const scrollToTop = createAction(types.SCROLL_TO_TOP);
const scrollToCenter = createAction(types.SCROLL_TO_CENTER);
const scrollIntoView = createAction(types.SCROLL_INTO_VIEW);
const setLang = createAction(types.SET_LANG);
const openTab = createAction(types.OPEN_TAB);
const addAccountNavigation = createAction(types.ADD_ACCOUNT_NAVIGATION);
const setAccountNavigationActive = createAction(types.SET_ACCOUNT_NAVIGATION_ACTIVE);
const setVariantSelectStatus = createAction(types.VARIANT_SELECT_STATUS);
const setFlyDownEffect = createAction(types.SET_FLY_DOWN_EFFECT);
const resetFlyDownEffect = createAction(types.RESET_FLY_DOWN_EFFECT);
const setAutoLoginMessage = createAction(types.SET_AUTO_LOGIN_MESSAGE);
const setConnectedAndShow = createAction(types.CONNECTED_AND_SHOW);
const setConnectedAndShowContainer = createAction(types.CONNECTED_AND_SHOW_CONTAINER);

const _addTabLink = createAction(types.ADD_TAB_LINK);
const addTabLink = (label, tabName) => _addTabLink({ label, tabName });

const windowResize = (width, height) => _windowResize({ width, height });

const setMinicartPopoverData = data => _setMinicartPopoverData({ ...data });

const setPopoverStatus = createAction(types.SET_POPOVER_STATUS);
const setLoginPopoverOpened = createAction(types.SET_LOGIN_POPOVER_OPENED);
const storeInfoStatus = createAction(types.STORE_INFO_STATUS);

const _toggleMinicartPopover = createAction(types.TOOGLE_MINICART_POPOVER_DATA);
const toggleMinicartPopover = (isOpened, isDisabled) =>
    _toggleMinicartPopover({ isOpened, isDisabled });
const forceCloseMinicartPopover = createAction(types.FORCE_CLOSE_MINICART_POPOVER);

const _initialize = createAction(types.INITIALIZE);
const initialize = () => _initialize({});

const _setMinicartForcedMessages = createAction(types.SET_MINICART_FORCED_MESSAGES);
const setMiniCartForcedMessages = messages => _setMinicartForcedMessages(messages);
const removeMiniCartForcedMessages = createAction(types.REMOVE_MINICART_FORCED_MESSAGES);

const setNavigation = createAction(types.SET_NAVIGATION);
const setMyAccountNavigation = createAction(types.SET_MY_ACCOUNT_NAVIGATION);

const accordionOpen = createAction(types.ACCORDION_OPEN);
const accordionClose = createAction(types.ACCORDION_CLOSE);

const preventClick = createAction(types.PREVENT_CLICK);

const normalizeDatepicker = createAction(types.NORMALIZE_DATEPICKER);
const setHeaderScrolled = createAction(types.SET_HEADER_SCROLLED);
const setPageScrolledDown = createAction(types.SET_PAGE_SCROLLED_DOWN);
const setHoveredMiniCartProduct = createAction(types.SET_HOVERED_MINI_CART_PRODUCT);

const _setFacetSearchValue = createAction(types.SET_FACET_SEARCH_VALUE);
const setFacetSearchValue = value => _setFacetSearchValue(value);

const openReviewsWrapper = createAction(types.OPEN_REVIEWS_WRAPPER);
const closeReviewsWrapper = createAction(types.CLOSE_REVIEWS_WRAPPER);

const setPageViewType = createAction(types.SET_PAGE_VIEW_TYPE);
const resetPageViewType = createAction(types.RESET_PAGE_VIEW_TYPE);

const scrollToAnchorGroup = createAction(types.SCROLL_TO_ANCHOR_GROUP);
const resetScrollAnchorGroup = createAction(types.RESET_SCROLL_ANCHOR_GROUP);

const setPlpViewTypes = createAction(types.SET_PLP_VIEW_TYPES);
const setPlpViewType = createAction(types.SET_PLP_VIEW_TYPE);

const setContentItemsAmount = createAction(types.SET_CONTENT_ITEMS_AMOUNT);

const toggleStickyBar = createAction(types.STICKY_BAR_TOGGLE);
const setCustomHandleClose = createAction(types.SET_CUSTOM_HANDLE_CLOSE);

const showTopBrands = createAction(types.TOP_BRANDS_SHOW);
const hideTopBrands = createAction(types.TOP_BRANDS_HIDE);

const addElementsToRefresh = createAction(types.ADD_ELEMENTS_TO_REFRESH);
const removeElementToRefresh = createAction(types.REMOVE_ELEMENT_TO_REFRESH);

const clearStatusCode = createAction(types.CLEAR_STATUS_CODE);

const showNewsletterDisclaimer = createAction(types.NEWSLETTER_DISCLAIMER_SHOW);

const scrollToTopOfPage = () => scrollToTop({ target: '.e2-page' });
const setHoveredGWPProduct = createAction(types.SET_HOVERED_GWP_PRODUCT);
const bvInitialize = createAction(types.BV_INITIALIZE);
const showAddVoucherForm = createAction(types.SHOW_ADD_VOUCHER_FORM);
const hideAddVoucherForm = createAction(types.HIDE_ADD_VOUCHER_FORM);
const setActiveAlphabetFilter = createAction(types.SET_ACTIVE_ALPHABET_FILTER);
const clearActiveAlphabetFilter = createAction(types.CLEAR_ACTIVE_ALPHABET_FILTER);

const contentViewChanged = createAction(types.CONTENT_VIEW_CHANGED);

const expandAccordion = createAction(types.EXPAND_ACCORDION);
const resetExpandedAccordions = createAction(types.RESET_EXPANDED_ACCORDIONS);

const showGwpItems = createAction(types.SHOW_GWP_ITEMS);

const unlockGwpFlow = createAction(types.UNLOCK_GWP_FLOW);

const navigateToPDP = createAction(types.FORCE_CLICK_AVAILABILITY_IN_BRANCH);
const notifyIframe = createAction(types.NOTIFY_IFRAME);
export const registerIframe = createAction(types.REGISTER_IFRAME);
const scrollToTarget = createAction(types.SCROLL_TO_TARGET);

const setMinItemsToShow = createAction(types.SET_MIN_ITEMS_TO_SHOW);
const clearPincode = createAction(types.CLEAR_PINCODE);
const openLightPopup = createAction(types.OPEN_LIGHT_POPUP);
const closeLightPopup = createAction(types.CLOSE_LIGHT_POPUP);

export default {
    setMinicartPopoverData,
    toggleMinicartPopover,
    setPopoverStatus,
    setLoginPopoverOpened,
    initialize,
    setWindowSize,
    windowResize,
    showModal,
    closeModal,
    storeInfoStatus,
    okModal,
    cancelModal,
    setScrollTop,
    scrollToTop,
    scrollToCenter,
    scrollIntoView,
    setLang,
    hideFiltersMenu,
    showFiltersMenu,
    scrollToAppliedFilter,
    setMiniCartForcedMessages,
    removeMiniCartForcedMessages,
    openDialog,
    closeDialog,
    closeDialogByName,
    openTab,
    addTabLink,
    addAccountNavigation,
    setAccountNavigationActive,
    setNavigation,
    setMyAccountNavigation,
    setFlyDownEffect,
    resetFlyDownEffect,
    accordionOpen,
    accordionClose,
    preventClick,
    setVariantSelectStatus,
    normalizeDatepicker,
    addToVisibleElements,
    removeFromVisibleElements,
    setHeaderScrolled,
    setPageScrolledDown,
    setHoveredMiniCartProduct,
    setAutoLoginMessage,
    setFacetSearchValue,
    openReviewsWrapper,
    closeReviewsWrapper,
    setPageViewType,
    resetPageViewType,
    scrollToAnchorGroup,
    resetScrollAnchorGroup,
    setPlpViewTypes,
    setPlpViewType,
    setContentItemsAmount,
    toggleStickyBar,
    setCustomHandleClose,
    showTopBrands,
    hideTopBrands,
    clearStatusCode,
    showNewsletterDisclaimer,
    addElementsToRefresh,
    removeElementToRefresh,
    scrollToTopOfPage,
    setHoveredGWPProduct,
    forceCloseMinicartPopover,
    bvInitialize,
    showAddVoucherForm,
    hideAddVoucherForm,
    setActiveAlphabetFilter,
    contentViewChanged,
    clearActiveAlphabetFilter,
    expandAccordion,
    resetExpandedAccordions,
    showGwpItems,
    unlockGwpFlow,
    setConnectedAndShow,
    setConnectedAndShowContainer,
    navigateToPDP,
    setMinItemsToShow,
    registerIframe,
    notifyIframe,
    scrollToTarget,
    clearPincode,
    openLightPopup,
    closeLightPopup,
};
